import { render, staticRenderFns } from "./ChangeCon.vue?vue&type=template&id=4422a7ba&scoped=true"
import script from "./ChangeCon.vue?vue&type=script&lang=js"
export * from "./ChangeCon.vue?vue&type=script&lang=js"
import style0 from "./ChangeCon.vue?vue&type=style&index=0&id=4422a7ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4422a7ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4422a7ba')) {
      api.createRecord('4422a7ba', component.options)
    } else {
      api.reload('4422a7ba', component.options)
    }
    module.hot.accept("./ChangeCon.vue?vue&type=template&id=4422a7ba&scoped=true", function () {
      api.rerender('4422a7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/synthesize/officialDocProcess/components/ChangeCon.vue"
export default component.exports